<template>
  <!--物流地图-->
  <div class="logisContainer">
    <!--地图区域-->
    <div
      class="map"
      v-show="tableWinType != 'max'"
      :style="{ height: height_map + 'px' }"
    >
      <!--地图组件-->
      <LogisticsMap
        ref="aLogisMap"
        :markerDatas="markerDatas"
        :areaDatas="areaDatas"
        :xzAreaDatas="xzAreaDatas"
        :mapAuth.sync="mapAuth"
        :categoryList.sync="categoryList"
        :organizations.sync="organizations"
        :isFullScreen.sync="isFullScreen"
        @init="mapInitBack"
        @saveOverlay="saveOverlay"
        @fullScreen="fullScreen"
      ></LogisticsMap>
    </div>
    <div class="location_search">
      <el-input
        id="locationTex"
        size="small"
        clearable
        v-model="locationAddress"
        placeholder="请输入地址搜索"
      ></el-input>
    </div>
    <!--表格区域-->
    <div class="list">
      <e6-resizer :top="height_map" @move="resizerMove" :min="34"></e6-resizer>
      <!--表格区域顶部tab及操作条-->
      <div class="listTop clearfix">
        <!--tab标签-->
        <div class="fl">
          <e6Tab :tabList="statTabList" @tabChange="statTabChange"></e6Tab>
        </div>
        <!--操作条-->
        <div class="fr">
          <!--搜索-->
          <el-input
            size="mini"
            placeholder="搜索"
            class="searchBox iconInp"
            v-model="searchTxt"
            @keydown.native.enter="listSearch"
          >
            <i
              class="e6-icon-search_line"
              slot="suffix"
              @click="listSearch"
            ></i>
          </el-input>
          <!--添加点-->
          <el-tooltip
            class="item"
            effect="dark"
            :hide-after="2000"
            transition="el-zoom-in-bottom"
            :content="cur_tab == 'marker' ? '点击后前往地图上标注' : '添加'"
            placement="top"
          >
            <i
              class="e6-icon-add_line"
              v-show="
                mapAuth.物流地图.自定义点及区域管理.add && cur_tab != 'line'
              "
              @click="addBtnClick"
            ></i>
          </el-tooltip>
          <!--导入 - 区域-->
          <!-- <el-tooltip
            class="item"
            effect="dark"
            :hide-after="2000"
            transition="el-zoom-in-bottom"
            content="导入"
            placement="top"
          >
            <i class="e6-icon-Import_line" @click="openImport"></i>
          </el-tooltip> -->
          <el-dropdown
            :hide-on-click="false"
            placement="top"
            @command="importEvent"
          >
            <span class="el-dropdown-link">
              <i class="e6-icon-Import_line"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">按照经纬度导入</el-dropdown-item>
              <el-dropdown-item command="2">按照地址导入</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--导出-->
          <el-tooltip
            class="item"
            effect="dark"
            :hide-after="2000"
            transition="el-zoom-in-bottom"
            content="导出"
            placement="top"
          >
            <i class="e6-icon-export_line" @click="exportClick"></i>
          </el-tooltip>
          <!--批量删除-->
          <el-tooltip
            class="item"
            effect="dark"
            :hide-after="2000"
            transition="el-zoom-in-bottom"
            content="批量删除"
            placement="top"
          >
            <i
              v-show="
                mapAuth.物流地图.自定义点及区域管理.del ||
                  mapAuth.物流地图.自定义线路管理.del
              "
              class="e6-icon-delete_line"
              @click="batchDelete"
            ></i>
          </el-tooltip>
          <!--清除临时叠加物-->
          <el-tooltip
            class="item"
            effect="dark"
            :hide-after="2000"
            transition="el-zoom-in-bottom"
            content="清除临时叠加物"
            placement="top"
          >
            <i class="e6-icon-clear_line" @click="removeTempOverlay"></i>
          </el-tooltip>
          <!--最小化-->
          <el-tooltip
            class="item"
            effect="dark"
            :hide-after="2000"
            transition="el-zoom-in-bottom"
            content="最小化"
            placement="top"
          >
            <i
              v-show="tableWinType != 'min'"
              class="e6-icon-minus_line"
              @click="changeTableStatus('min')"
            ></i>
          </el-tooltip>
          <!--窗口化-->
          <el-tooltip
            class="item"
            effect="dark"
            :hide-after="2000"
            transition="el-zoom-in-bottom"
            content="窗口化"
            placement="top"
          >
            <i
              v-show="tableWinType != 'win'"
              class="e6-icon-window-window_line"
              @click="changeTableStatus('win')"
            ></i>
          </el-tooltip>
        </div>
      </div>
      <!--表格主体-->
      <div
        class="tableBox"
        v-show="tableWinType != 'min'"
        :style="{ height: height_table + 'px' }"
      >
        <!--点表格-->
        <el-table
          v-show="cur_tab == 'marker'"
          ref="table_marker"
          :data="tableDatas_marker"
          :height="height_table"
          :row-height="28"
          useVirtual
          border
          stripe
          highlight-current-row
          empty-text=" "
          style="width: 100%"
          @selection-change="mSelectionChange"
          @row-click="rowClick_marker"
        >
          <el-table-column
            fixed
            align="center"
            type="selection"
            width="65"
            :v-model="true"
          ></el-table-column>
          <el-table-column
            fixed
            align="center"
            type="index"
            width="65"
            label="序号"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in logisticsJson.tableCols_marker"
            :key="index"
            :property="item.prop"
            :label="item.label"
            :fixed="item.fixed"
            :min-width="item.minWidth"
            :show-overflow-tooltip="true"
            :align="item.align ? item.align : 'left'"
            header-align="center"
          ></el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            width="150"
            class-name="operCol"
            label="操作"
          >
            <template v-slot="scope">
              <!-- <e6-td-operate
                :data="markerOption"
                @command="mOptionCallBack($event, scope.row)"
              ></e6-td-operate> -->
              <span class="operate" @click="aEditClick(scope.row)">修改</span>
              <span class="operate" @click="mDeleteClick(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <!--区域表格-->
        <el-table
          v-show="cur_tab == 'area'"
          highlight-current-row
          ref="table_area"
          :data="tableDatas_area"
          :height="height_table"
          :row-height="28"
          useVirtual
          border
          empty-text=" "
          style="width: 100%"
          @selection-change="aSelectionChange"
          @row-click="rowClick_area"
        >
          <el-table-column
            fixed
            align="center"
            type="selection"
            width="65"
            :v-model="true"
          ></el-table-column>
          <el-table-column
            fixed
            type="index"
            align="center"
            width="80"
            label="序号"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in logisticsJson.tableCols_area"
            :key="index"
            :property="item.prop"
            :label="item.label"
            :fixed="item.fixed"
            :min-width="item.minWidth"
            :show-overflow-tooltip="true"
            :align="item.align ? item.align : 'left'"
            header-align="center"
          ></el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            width="150"
            class-name="operCol"
            label="操作"
          >
            <template v-slot="scope">
              <span class="operate" @click="aEditClick(scope.row)">修改</span>
              <span class="operate" @click="aDeleteClick(scope.row)">删除</span>
              <!-- <e6-td-operate
                :data="markerOption"
                @command="aOptionCallBack($event, scope.row)"
              ></e6-td-operate> -->
            </template>
          </el-table-column>
        </el-table>
        <!--行政区域表格-->
        <el-table
          v-show="cur_tab == 'xzArea'"
          highlight-current-row
          ref="table_area"
          :data="tableDatas_xzArea"
          :height="height_table"
          :row-height="28"
          useVirtual
          border
          empty-text=" "
          style="width: 100%"
          @selection-change="xzAreaSelectionChange"
          @row-click="rowClick_xzArea"
        >
          <el-table-column
            fixed
            align="center"
            type="selection"
            width="65"
            :v-model="true"
          ></el-table-column>
          <el-table-column
            fixed
            type="index"
            align="center"
            width="80"
            label="序号"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in logisticsJson.tableCols_area"
            :key="index"
            :property="item.prop"
            :label="item.label"
            :fixed="item.fixed"
            :min-width="item.minWidth"
            :show-overflow-tooltip="true"
            :align="item.align ? item.align : 'left'"
            header-align="center"
          ></el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            width="150"
            class-name="operCol"
            label="操作"
          >
            <template v-slot="scope">
              <span class="operate" @click="xzAreaEditClick(scope.row)"
                >修改</span
              >
              <span class="operate" @click="xzAreaDeleteClick(scope.row)"
                >删除</span
              >
              <!-- <e6-td-operate
                :data="markerOption"
                @command="xzOptionCallBack($event, scope.row)"
              ></e6-td-operate> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 查看点区域修改历史 -->
    <e6-box
      class="mod-history"
      ref="modHistory"
      title="修改历史"
      @closeFun="closeModHistory"
    >
      <!--修改历史表格-->
      <el-table
        highlight-current-row
        ref="table_history"
        :data="tableHistory"
        :height="300"
        :row-height="26"
        useVirtual
        border
        empty-text=" "
        @row-click="rowClick_history"
      >
        <el-table-column
          fixed
          type="index"
          align="center"
          width="55"
          label="序号"
        ></el-table-column>
        <el-table-column
          property="modifiedUserName"
          align="left"
          width="124"
          label="修改人"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          property="modifiedTimeStr"
          align="center"
          width="140"
          label="修改时间"
        ></el-table-column>
        <el-table-column
          property="operateTypeStr"
          align="center"
          width="80"
          label="类型"
        ></el-table-column>
      </el-table>
    </e6-box>

    <!--导入弹框-->
    <upload-center
      ref="addGoodsFile"
      :visible.sync="dialogImportVisible"
      :initInfo="importParams"
      @update:visible="updateSuccess"
    ></upload-center>
    <!--导入弹框-->
    <upload-center
      ref="addGoodsFile"
      :visible.sync="dialogImportVisible1"
      :initInfo="importParams1"
      @update:visible="updateSuccess1"
    ></upload-center>
  </div>
</template>

<script>
import "@/assets/css/map/e6_common.scss";
import "@/assets/css/map/logistics.scss";
import logisticsJson from "./logistics.json";
import LogisticsMap from "@/components/logisticsMap";
import e6Resizer from "@/components/e6Resizer";
import e6Tab from "@/components/e6Tab";
import e6Box from "@/components/e6Box";
import { mixin } from "@/mixins/logisOverlaysHandle.js";
import {
  fetchAreaDatas_Api,
  deleteMarkers_Api,
  exportCustomArea
} from "@/api/monitorCenter/logisticsMap";
import { exportXlsx } from "@/utils/exportXlsx.js";

import { FetchFindOrganizationTreeByOrgId } from "@/_private/api/public";
import uploadCenter from "@/components/uploadCenter";
// import { exportXlsx } from "e6-base-carrier/utils/util";
export default {
  name: "mapAreaList",
  mixins: [mixin],
  components: {
    LogisticsMap,
    e6Tab,
    e6Box,
    e6Resizer,
    uploadCenter
  },
  data() {
    return {
      HEIGHT_WIN_TABLE: 200, //窗口化的高度
      height_map: 500, // 地图高度
      height_table: 200, // 表格高度
      mapName: "aLogisMap",
      logisticsJson,
      // 表格标签
      statTabList: [
        {
          type: "点",
          isActive: true,
          selected: { name: "圆形区域", num: 0, classify: "marker" }
        },
        {
          type: "区域",
          isActive: false,
          selected: { name: "区域", num: 0, classify: "area" }
        },
        {
          type: "行政区域",
          isActive: false,
          selected: { name: "行政区域", num: 0, classify: "xzArea" }
        }
      ],
      mapAuth: null, // 权限数据
      organizations: [], // 部门树
      categoryList: [], // 区域类型
      tableWinType: "win", // 'min', 'win'
      tableHistory: [], // 修改历史 列表数据
      markerDatas: [], // 接口返回的 点数据
      tableDatas_marker: [], // 表格点数据
      areaDatas: [], // 接口返回的 区域数据
      tableDatas_area: [], // 表格区域数据
      xzAreaDatas: [], // 接口返回的 行政区域数据
      tableDatas_xzArea: [], // 表格行政区域数据
      // tableDatas_line: [], // 表格线路数据
      searchTxt: "", // 搜索的文本
      // selection_marker: [], // 所选择的点
      selection_area: [], // 所选择的区域
      selection_xzArea: [], // 所选择的行政区域
      // selection_line: [], // 所选择的行政区域
      tempOverlay: null, //点击列表地图上临时的叠加物
      tempOverlay_marker: [], //点击列表地图上临时的叠加物
      // 权限相关
      mapAuthData: {
        物流地图: {
          自定义点及区域管理: {
            exp: false,
            ipm: false,
            add: false,
            query: false,
            pic: false,
            ter: false,
            mod: false,
            del: false
          }
        }
      },
      // 位置搜索
      locationAddress: "",
      // 导入相关
      dialogImportVisible: false,
      dialogImportVisible1: false,
      importParams: {
        title: "按照经纬度导入电子围栏",
        templateUrl: "/static/按经纬度导入点.xls",
        importUrl: "/monitorCenter/logisticsMap/importPointLatLon"
      },
      importParams1: {
        title: "按照地址导入电子围栏",
        templateUrl: "/static/地址导入模板.xls",
        importUrl: "/monitorCenter/logisticsMap/importPointArea"
      },
      exportUrl: "/monitorCenter/logisticsMap/exportCustomArea"
    };
  },
  computed: {
    // 当前活动的表格的名称
    cur_tab() {
      let curTab = this.statTabList.find(item => {
        return item.isActive;
      });
      return curTab ? curTab.selected.classify : "";
    },
    markerOption() {
      let options = [];
      if (this.mapAuth.物流地图.自定义点及区域管理.mod) {
        options.push({ label: "修改" });
      }
      if (this.mapAuth.物流地图.自定义点及区域管理.del) {
        options.push({ label: "删除" });
      }
      if (this.mapAuth.物流地图.自定义点及区域管理.query) {
        options.push({ label: "查看修改历史" });
      }
      return options;
    }
  },
  watch: {
    // 表格高度改变，重新计算各个区域size
    height_table: function() {
      this.pageResize();
    },
    isFullScreen: function() {
      // this.isFold_right = !this.isFold_right;
      this.isFullScreen
        ? this.changeTableStatus("min")
        : this.changeTableStatus("win");
      this.pageResize();
    },
    // 点数据改变，更新点表格
    markerDatas: {
      handler: function() {
        this.loadTable_marker();
      },
      immediate: true
    },
    // 普通区域数据改变，更新点表格
    areaDatas: {
      handler: function() {
        this.loadTable_area();
      },
      immediate: true
    },
    // 行政区域数据改变，更新点表格
    xzAreaDatas: {
      handler: function() {
        this.loadTable_xzArea();
      },
      immediate: true
    }
    // // 线路数据改变，更新点表格
    // lineDatas: {
    //   handler: function() {
    //     this.loadTable_line();
    //   },
    //   immediate: true
    // }
  },
  methods: {
    // 获取操作权限
    getPermissions() {
      let res = {
        code: 1,
        message: "OK",
        result: {
          物流地图: {
            自定义点及区域管理: {
              exp: false,
              ipm: false,
              add: true,
              query: false,
              pic: false,
              ter: false,
              mod: true,
              del: true
            }
          }
        }
      };
      if (res.code === 1 && res.result) {
        this.mapAuth = res.result;
      }
    },
    // 获取部门树
    getOrganization() {
      FetchFindOrganizationTreeByOrgId()
        .then(res => {
          if (res.code === 1 && res.result) {
            this.organizations = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取物流地图区域数据 包括普通区域与行政区域
    async fetchAreaDatas() {
      // return new Promise(async resolve => {
      let res = await fetchAreaDatas_Api();
      let areaData = []; // 普通区域
      let xzAreaData = []; // 行政区域
      let markersData = []; // 点 圆形区域
      if (Array.isArray(res)) {
        res.forEach(area => {
          if (area.typeId == 3) {
            markersData.push(area);
          }
          if (area.typeId == 2 || area.typeId == 1) {
            areaData.push(area);
          }
          if (area.typeId == 4) {
            xzAreaData.push(area);
          }
        });
      }
      this.areaDatas = areaData;
      this.xzAreaDatas = xzAreaData;
      this.markerDatas = markersData;
      // resolve(res);
      // });
    },
    mapInitBack(map) {
      let _this_ = this;
      map.plugin(
        ["AMap.Autocomplete", "AMap.PlaceSearch", "AMap.Geocoder"],
        () => {
          let autocomplete = new AMap.Autocomplete({
            input: "locationTex"
          });
          AMap.event.addListener(autocomplete, "select", e => {
            if (e.poi.location && e.poi.location.lat && e.poi.location.lng) {
              let llObj = _this_.$refs.aLogisMap.mapAPI.createLngLat({
                lng02: e.poi.location.lng,
                lat02: e.poi.location.lat
              });
              _this_.$refs.aLogisMap.mapAPI.setZoomAndCenter(14, llObj);
            } else {
              _this_.$message("无法精确定位，请重新输入");
            }
          }); //注册监听，当选中某条记录时会触发
        }
      );
    },
    // saveOverlay() {},

    // 页面resize事件
    pageResize() {
      const height_map =
        document.querySelector(".logisContainer").clientHeight -
        document.querySelector(".listTop").offsetHeight -
        this.height_table -
        6;
      this.height_map = height_map >= 0 ? height_map : 0;
      this.$refs.aLogisMap.resize();
    },
    // 页面全屏
    // fullScreenChange() {
    //   this.setFullScreenAct(!this.isFullScreen).then(() => {
    //     this.changeTableStatus("min");
    //     this.pageResize();
    //   });
    // },
    // 切换表格尺寸
    changeTableStatus(wType) {
      this.tableWinType = wType;
      switch (wType) {
        case "min":
          this.height_table = 0;
          break;
        case "win":
          this.height_table = this.HEIGHT_WIN_TABLE;
          break;
      }
    },
    resizerMove(top) {
      this.tableWinType = "win";
      this.height_table =
        document.querySelector(".logisContainer").clientHeight -
        top -
        document.querySelector(".resizer-drag").clientHeight -
        document.querySelector(".listTop").clientHeight +
        6;
      this.$nextTick(() => {
        this.pageResize();
      });
    },
    // 切换表格
    statTabChange(opts) {
      // 清空搜索文本
      this.searchTxt = "";
      this.statTabList.forEach(tab => {
        if (tab.type == opts.type) {
          tab.isActive = true;
          tab.selected = JSON.parse(JSON.stringify(opts.selected));
        } else {
          tab.isActive = false;
        }
      });
      // 窗口化
      if (this.tableWinType == "min") {
        this.changeTableStatus("win");
      }
    },
    // 加载点表格数据
    loadTable_marker() {
      this.tableDatas_marker = this.markerDatas;
      this.dealTabNum();
    },
    // 加载普通区域表格数据
    loadTable_area() {
      this.tableDatas_area = this.areaDatas;
      this.dealTabNum();
    },
    // 加载普通区域表格数据
    loadTable_xzArea() {
      this.tableDatas_xzArea = this.xzAreaDatas;
      this.dealTabNum();
    },
    // // 加载线路表格数据
    // loadTable_line() {
    //   this.tableDatas_line = this.lineDatas;
    //   this.dealTabNum();
    // },
    // 循化处理tab标签后的数量
    dealTabNum() {
      // tab数据
      this.statTabList.forEach(item => {
        switch (item.type) {
          case "点":
            item.selected.num =
              this.tableDatas_marker.length == this.markerDatas.length
                ? this.tableDatas_marker.length
                : `${this.tableDatas_marker.length}/${this.markerDatas.length}`;
            break;
          case "区域":
            item.selected.num =
              this.tableDatas_area.length == this.areaDatas.length
                ? this.tableDatas_area.length
                : `${this.tableDatas_area.length}/${this.areaDatas.length}`;
            break;
          case "行政区域":
            item.selected.num =
              this.tableDatas_xzArea.length == this.xzAreaDatas.length
                ? this.tableDatas_xzArea.length
                : `${this.tableDatas_xzArea.length}/${this.xzAreaDatas.length}`;
            break;
          // case "线路":
          //   item.selected.num =
          //     this.tableDatas_line.length == this.lineDatas.length
          //       ? this.tableDatas_line.length
          //       : `${this.tableDatas_line.length}/${this.lineDatas.length}`;
          //   break;
          default:
            break;
        }
      });
    },
    // 表格搜索事件
    listSearch() {
      this.searchTxt = this.searchTxt.trim();
      switch (this.cur_tab) {
        case "marker":
          if (this.searchTxt == "") {
            this.tableDatas_marker = this.markerDatas;
          } else {
            this.tableDatas_marker = this.markerDatas.filter(item => {
              return item.areaName.indexOf(this.searchTxt) >= 0;
            });
          }
          break;
        case "area":
          if (this.searchTxt == "") {
            this.tableDatas_area = this.areaDatas;
          } else {
            this.tableDatas_area = this.areaDatas.filter(item => {
              return item.areaName.indexOf(this.searchTxt) >= 0;
            });
          }
          break;
        case "xzArea":
          if (this.searchTxt == "") {
            this.tableDatas_xzArea = this.xzAreaDatas;
          } else {
            this.tableDatas_xzArea = this.xzAreaDatas.filter(item => {
              return item.areaName.indexOf(this.searchTxt) >= 0;
            });
          }
          break;
        // case "line":
        //   if (this.searchTxt == "") {
        //     this.tableDatas_line = this.lineDatas;
        //   } else {
        //     this.tableDatas_line = this.lineDatas.filter(item => {
        //       return item.lineName.indexOf(this.searchTxt) >= 0;
        //     });
        //   }
        //   break;
        default:
          break;
      }
      this.dealTabNum();
    },
    // 添加按钮事件
    addBtnClick() {
      switch (this.cur_tab) {
        case "marker":
          this.$refs.aLogisMap.markOverlay("marker");
          break;
        case "area":
          this.$refs.aLogisMap.operType = 2;
          this.$refs.aLogisMap.aParams = {
            id: 0,
            name: "",
            titleColor: "#48494c",
            areaAcreage: 0,
            acreageColor: "#409eff",
            categoryId: "",
            code: "",
            orgId: 0,
            share: 1,
            lng84: null,
            lat84: null,
            lng02: null,
            lat02: null,
            address: "",
            contact: "",
            telephone: "",
            remark: "",
            llObjArr: [],
            typeId: 1 //图形类型  1 - 矩形, 2 - 多边形
          };
          this.$refs.aLogisMap.openMarkTypeLayer(false);
          break;
        case "xzArea":
          this.$refs.aLogisMap.markOverlay("areaXz");
          break;
        default:
          break;
      }
    },
    // 批量删除
    batchDelete() {
      let delIdArr = [];
      switch (this.cur_tab) {
        case "marker":
          if (!this.mapAuth.物流地图.自定义点及区域管理.del) {
            this.$message({
              showClose: true,
              message: "您没有权限",
              type: "warning",
              center: true
            });
            return;
          }
          delIdArr = this.selection_marker.map(item => {
            return item.areaId;
          });
          this.deleteMarkers({ delIdArr });
          break;
        case "area":
          if (!this.mapAuth.物流地图.自定义点及区域管理.del) {
            this.$message({
              showClose: true,
              message: "您没有权限",
              type: "warning",
              center: true
            });
            return;
          }
          delIdArr = this.selection_area.map(item => {
            return item.areaId;
          });
          this.deleteAreas({ delIdArr });
          break;
        case "xzArea":
          if (!this.mapAuth.物流地图.自定义点及区域管理.del) {
            this.$message({
              showClose: true,
              message: "您没有权限",
              type: "warning",
              center: true
            });
            return;
          }
          delIdArr = this.selection_xzArea.map(item => {
            return item.areaId;
          });
          this.deleteXzAreas({ delIdArr });
          break;
        case "line":
          if (!this.mapAuth.物流地图.自定义线路管理.del) {
            this.$message({
              showClose: true,
              message: "您没有权限",
              type: "warning",
              center: true
            });
            return;
          }
          delIdArr = this.selection_line.map(item => {
            return item.lineId;
          });
          this.deleteLines({ delIdArr });
          break;
        default:
          break;
      }
    },
    /*------------------------------导入-----------------------------------*/
    importEvent(command) {
      if (command === "1") {
        this.dialogImportVisible = true;
      } else {
        this.dialogImportVisible1 = true;
      }
    },
    updateSuccess(val) {
      if (val) {
        this.dialogImportVisible = false;
      }
    },
    updateSuccess1(val) {
      if (val) {
        this.dialogImportVisible1 = false;
      }
    },
    // 导出
    async exportClick() {
      const res = await exportCustomArea({
        areaName: this.searchTxt
      });
      // 导出
      exportXlsx(res, `区域基础信息.xls`);
    },
    // 获取修改历史记录
    async getHistory(areaId) {
      let res = await this.mapLogisticsApi.getHistory(areaId);
      if (res.code == 1 && res.result && Array.isArray(res.result)) {
        this.tableHistory = res.result;
      }
      this.$refs.modHistory.showBox();
    },
    // 关闭修改历史
    closeModHistory() {
      if (this.tempOverlay) {
        this.$refs.aLogisMap.mapAPI.removeOverlay(this.tempOverlay);
        this.tempOverlay = null;
        if (this.tempOverlay_marker.length) {
          this.$refs.aLogisMap.mapAPI.closeInfoWindow(
            this.tempOverlay_marker[0]
          );
          this.$refs.aLogisMap.mapAPI.removeOverlay(this.tempOverlay_marker);
          this.tempOverlay_marker = [];
        }
      }
    },
    // 修改历史 列表点击行事件
    rowClick_history(row) {
      // 2:多边形,1:矩形,3:圆形
      switch (row.typeId) {
        case 1:
          this.rowClick_area(row);
          break;
        case 2:
          this.rowClick_area(row);
          break;
        case 3:
          this.rowClick_marker(row);
          break;
        default:
          break;
      }
    },
    /************************************marker***********************************/
    // 操作点击触发方法
    mOptionCallBack(option, row) {
      switch (option.label) {
        case "修改":
          this.mEditClick(row);
          break;
        case "删除":
          this.mDeleteClick(row);
          break;
        case "查看修改历史":
          this.getHistory(row.areaId);
          break;
      }
    },
    mEditById(data) {
      this.$refs.aLogisMap.mEditById(data);
    },
    // 点击修改点按钮
    mEditClick(row) {
      this.$refs.aLogisMap.mEditClick(row);
    },
    // 点击删除点按钮
    mDeleteClick(row) {
      this.deleteMarkers({ delIdArr: [row.areaId], name: row.areaName });
    },
    // 删除点
    deleteMarkers({ delIdArr = [], name = "" }) {
      if (delIdArr.length == 0) {
        this.$message({
          message: "请先选择要删除的点",
          type: "warning"
        });
        return;
      }
      this.$confirm(
        "确定要删除" + (name == "" ? "选中的点" : `点“${name}”`) + "吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        let res = await deleteMarkers_Api(delIdArr);
        if (res.code == 1) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.$refs.aLogisMap.deleteLogisAreas(delIdArr);
          this.removeTempOverlay();
          this.fetchAreaDatas();
          // this.fetchAreaDatas_mixin({ dealType: 2, params: { delIdArr } });
        }
        // let res = await this.mapLogisticsApi.deleteMarkers_Api(delIdArr);
        // if (res.code == 1) {
        //   this.$message({
        //     message: "删除成功",
        //     type: "success"
        //   });
        //   this.$refs.aLogisMap.deleteLogisMarkers(delIdArr);
        //   this.fetchMarkerDatas_mixin({
        //     dealType: 2,
        //     params: { delIdArr }
        //   });
        // }
      });
    },
    // 选中点
    mSelectionChange(sArr) {
      this.selection_marker = sArr;
    },
    // 点击点表格行
    rowClick_marker(row) {
      this.$refs.aLogisMap.showTempMarkerById(row.areaId);
    },
    /************************************area***********************************/
    // 操作点击触发方法
    aOptionCallBack(option, row) {
      switch (option.label) {
        case "修改":
          this.aEditClick(row);
          break;
        case "删除":
          this.aDeleteClick(row);
          break;
      }
    },
    // 通过id修改区域或者行政区域
    aEditById(data) {
      this.$refs.aLogisMap.aEditById(data);
    },
    // 点击编辑区域按钮
    aEditClick(row) {
      this.$refs.aLogisMap.aEditClick(row);
    },
    // 点击删除区域按钮
    aDeleteClick(row) {
      this.deleteAreas({ delIdArr: [row.areaId], name: row.areaName });
    },
    // 删除区域的方法
    async deleteAreas({ delIdArr = [], name = "" }) {
      if (delIdArr.length == 0) {
        this.$message({
          message: "请先选择要删除的区域",
          type: "warning"
        });
        return;
      }
      this.$confirm(
        "确定要删除" + (name == "" ? "选中的区域" : `区域“${name}”`) + "吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        let res = await deleteMarkers_Api(delIdArr);
        if (res.code == 1) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.$refs.aLogisMap.deleteLogisAreas(delIdArr);
          this.removeTempOverlay();
          this.fetchAreaDatas();
          // this.fetchAreaDatas_mixin({ dealType: 2, params: { delIdArr } });
        }
      });
    },
    // 选中区域表格行
    aSelectionChange(sArr) {
      this.selection_area = sArr;
    },
    // 点击区域表格行
    rowClick_area(row) {
      this.$refs.aLogisMap.showTempAreaById(row.areaId);
    },
    /************************************xzArea***********************************/
    // 操作点击触发方法
    xzOptionCallBack(option, row) {
      switch (option.label) {
        case "修改":
          this.xzAreaEditClick(row);
          break;
        case "删除":
          this.xzAreaDeleteClick(row);
          break;
      }
    },
    // 点击编辑行政区域按钮
    xzAreaEditClick(row) {
      this.$refs.aLogisMap.xzAreaEditClick(row);
      // this.$refs.aLogisMap.aEditClick(row);
    },
    // 点击删除区域按钮
    xzAreaDeleteClick(row) {
      this.deleteXzAreas({ delIdArr: [row.areaId], name: row.areaName });
    },
    // 选中行政区域表格行
    xzAreaSelectionChange(sArr) {
      this.selection_xzArea = sArr;
    },
    // 删除行政区域的方法
    async deleteXzAreas({ delIdArr = [], name = "" }) {
      if (delIdArr.length == 0) {
        this.$message({
          message: "请先选择要删除的区域",
          type: "warning"
        });
        return;
      }
      this.$confirm(
        "确定要删除" + (name == "" ? "选中的区域" : `区域“${name}”`) + "吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        let res = await deleteMarkers_Api(delIdArr);
        if (res.code == 1) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.$refs.aLogisMap.deleteLogisAreas(delIdArr);
          this.removeTempOverlay();
          this.fetchAreaDatas();
          // this.fetchAreaDatas_mixin({ dealType: 2, params: { delIdArr } });
        }
      });
    },
    // 点击行政区域表格行
    rowClick_xzArea(row) {
      this.$refs.aLogisMap.showTempXzAreaById(row.areaId);
    },
    /************************************line***********************************/
    lEditClick(row) {
      this.lFetchDetailById(row.lineId).then(res => {
        this.$refs.aLogisMap.lOpenLayer(res);
      });
    },
    // 根据id查询详情信息
    async lFetchDetailById(id) {
      return new Promise(async (resolve, reject) => {
        let res = await this.mapLogisticsApi.fetchLineDetail_Api({ id });
        if (res.code == 1) {
          let lineData = res.result;
          let llObjArr = [];
          let aLnglatStr = lineData.lineLonLat.split(";");
          aLnglatStr.forEach(lnglatStr => {
            if (lnglatStr != "") {
              let llArr = lnglatStr.split(",");
              llObjArr.push({
                lng84: Number(llArr[1]),
                lat84: Number(llArr[0])
              });
            }
          });
          let opts = {
            id: lineData.lineId,
            name: lineData.lineName,
            code: lineData.lineCode,
            width: lineData.lineWidth,
            orgId: lineData.orgId,
            share: lineData.shareMode,
            odometer: lineData.lineOdoMeter,
            lineColor: lineData.lineColor,
            bposition: lineData.bPosition,
            eposition: lineData.ePosition,
            remark: lineData.remark,
            llObjArr: llObjArr
          };
          resolve(opts);
        } else {
          reject(res.msg);
        }
      });
    },
    // 点击删除线路
    lDeleteClick(row) {
      this.deleteLines({ delIdArr: [row.lineId], name: row.lineName });
    },
    // 删除线路方法
    async deleteLines({ delIdArr = [], name = "" }) {
      if (delIdArr.length == 0) {
        this.$message({
          message: "请先选择要删除的线",
          type: "warning"
        });
        return;
      }
      this.$confirm(
        "确定要删除" + (name == "" ? "选中的线" : `线“${name}”`) + "吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        let res = await this.mapLogisticsApi.deleteLines_Api(delIdArr);
        if (res.code == 1) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.fetchLineDatas_mixin({ dealType: 2, params: { delIdArr } });
        }
      });
    },
    // 选中线路表格行
    lSelectionChange(sArr) {
      this.selection_line = sArr;
    },
    // 点击表格行
    rowClick_line(row) {
      this.lFetchDetailById(row.lineId).then(res => {
        if (this.tempOverlay) {
          this.$refs.aLogisMap.mapAPI.removeOverlay(this.tempOverlay);
          this.tempOverlay = null;
        }
        if (this.tempOverlay_marker.length > 0) {
          this.$refs.aLogisMap.mapAPI.closeInfoWindow(
            this.tempOverlay_marker[0]
          );
          this.$refs.aLogisMap.mapAPI.removeOverlay(this.tempOverlay_marker);
          this.tempOverlay_marker = [];
        }
        let path = res.llObjArr.map(llObj => {
          return this.$refs.aLogisMap.mapAPI.createLngLat({
            lng84: llObj.lng84 || 0,
            lat84: llObj.lat84 || 0
          });
        });
        let tempOverlayLine = this.$refs.aLogisMap.mapAPI.createLine({
          path: path,
          strokeColor: res.lineColor,
          strokeWeight: res.width,
          extData: {
            type: "line"
          }
        });
        tempOverlayLine.extData = {
          type: "line"
        };
        this.tempOverlay = tempOverlayLine;
        this.$refs.aLogisMap.mapAPI.addOverlay(this.tempOverlay);
        //将line放在可视范围之内
        this.$refs.aLogisMap.mapAPI.setFitView({
          overlayList: [this.tempOverlay]
        });

        let spoint = {
          position: path[0],
          icon: require("e6-base-map/assets/e6Images/navigation/start.png"),
          label: row.bPosition,
          width: 32,
          height: 40,
          extData: {
            type: "start"
          }
        };
        let smarker = this.$refs.aLogisMap.mapAPI.createMarker(spoint);
        this.tempOverlay_marker.push(smarker);
        this.$refs.aLogisMap.mapAPI.addOverlay(smarker);
        let epoint = {
          position: path[path.length - 1],
          icon: require("e6-base-map/assets/e6Images/navigation/end.png"),
          label: row.ePosition,
          width: 32,
          height: 40,
          extData: {
            type: "end"
          }
        };
        let emarker = this.$refs.aLogisMap.mapAPI.createMarker(epoint);
        this.tempOverlay_marker.push(emarker);
        this.$refs.aLogisMap.mapAPI.addOverlay(emarker);
      });
    },
    // 清除临时覆盖物
    removeTempOverlay() {
      if (this.tempOverlay) {
        this.$refs.aLogisMap.mapAPI.closeInfoWindow(this.tempOverlay);
        this.$refs.aLogisMap.mapAPI.removeOverlay(this.tempOverlay);
        if (this.tempOverlay_marker.length > 0) {
          this.$refs.aLogisMap.mapAPI.closeInfoWindow(
            this.tempOverlay_marker[0]
          );
          this.$refs.aLogisMap.mapAPI.removeOverlay(this.tempOverlay_marker);
          this.tempOverlay_marker = [];

          this.$refs.aLogisMap.mapAPI.removeOverlay(this.tempOverlay_circle);
          this.tempOverlay_circle = [];
        }
      }
      this.$refs.aLogisMap.clearTempOverlay();
    },
    // 切换地图
    beforeMapChange() {
      // 清除临时覆盖物
      return new Promise(resolve => {
        this.removeTempOverlay();
        resolve();
      });
    }
  },
  created() {
    // 获取操作权限
    this.getPermissions();
    // 获取部门树
    this.getOrganization();
    // 获取区域类型
    // this.getDictionaryList();
    //获取物流地图区域数据
    this.fetchAreaDatas();
  },
  mounted() {
    // 计算页面尺寸
    this.pageResize();
    // 添加resize事件监听
    window.addEventListener("resize", this.pageResize);
  },
  beforeDestroy() {
    // 取消resize事件监听
    window.removeEventListener("resize", this.pageResize);
  }
};
</script>
<style lang="scss" scoped>
.operate {
  display: inline-block;
  margin-right: 15px;
  color: #46bfea;
  cursor: pointer;
}
.location_search {
  position: absolute;
  top: 7px;
  left: 270px;
  /deep/ .el-input__inner {
    width: 300px;
    height: 34px;
    line-height: 34px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  }
}
</style>
